import Icon from "@components/ui/icon";
import Tooltip from "@components/ui/tooltip";
import { cn } from "@lib/cn";
import { useMemo } from "react";
import { useLockedAction } from "../hooks";
import UpgradeButton from "./upgrade-button";

const PLAN_STYLES = {
  container: {
    starter: "tw-border-starter-border tw-bg-starter-base",
    pro: "tw-border-pro-border tw-bg-pro-base",
    team: "tw-border-team-border tw-bg-team-base",
  },
};

const UpgradeLabel = ({
  feature,
  tooltip: payloadTooltip,
  className,
  onClick,
  iconClassName,
}: {
  feature: string;
  tooltip?: string;
  className?: string;
  iconClassName?: string;
  onClick?: () => void;
}) => {
  const { value, plan } = useLockedAction({
    feature,
  });

  const tooltip = useMemo(() => {
    if (payloadTooltip) return normalizedTooltip(payloadTooltip);
    return "";
  }, [payloadTooltip]);

  if (value === null) return null;

  const label = (
    <div
      onKeyUp={(e) => {
        if (onClick) {
          e.stopPropagation();
          onClick();
        }
      }}
      onClick={(e) => {
        if (onClick) {
          e.stopPropagation();
          onClick();
        }
      }}
      className={cn(
        "tw-flex tw-size-[14px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-[3px] tw-border tw-border-solid tw-border-pro-border tw-bg-pro-base",
        onClick && "tw-cursor-pointer",
        PLAN_STYLES.container[plan as keyof typeof PLAN_STYLES.container],
        className,
      )}
    >
      <Icon
        icon="ri-vip-crown-fill"
        className={cn(
          "!tw-text-[9px] tw-font-normal !tw-text-white",
          iconClassName,
        )}
      />
    </div>
  );

  if (tooltip) {
    return (
      <Tooltip>
        <Tooltip.Trigger asChild>{label}</Tooltip.Trigger>
        <Tooltip.Content className="tw-z-[99999] tw-w-44 tw-rounded-lg tw-bg-blue tw-p-3">
          <p
            className="tw-mb-2 tw-mt-0 tw-font-sans tw-text-[11px]/tight tw-font-semibold tw-text-white"
            dangerouslySetInnerHTML={{ __html: normalizedTooltip(tooltip) }}
          />
          <UpgradeButton plan={plan} feature={feature} />
        </Tooltip.Content>
      </Tooltip>
    );
  }

  return label;
};
const normalizedTooltip = (tooltip: string) => {
  let normalizedText = tooltip;

  normalizedText = normalizedText.replace(/\bstarter\b/gi, "Starter");
  normalizedText = normalizedText.replace(/\bpro\b/gi, "Pro");
  normalizedText = normalizedText.replace(/\bteam\b/gi, "Team");

  return normalizedText;
};

export default UpgradeLabel;
